import React from "react";
import { useTranslation } from "react-i18next";
import {
    Box,
    Button,
    Dialog,
    DialogActions,
    DialogContent,
    DialogContentText,
    DialogTitle,
    TextField,
} from "@mui/material";
import * as companyService from "services/company-service";

interface IProps {
    open: boolean;
    onClose: () => void;
    refresh: () => void;
    tenantId?: string;
}

const CreateModal = (props: IProps) => {
    const [companyName, setCompanyName] = React.useState<string>("");
    const [companyValidNames, setCompanyValidNames] = React.useState<string[]>(
        [],
    );
    const [companyNameError, setCompanyNameError] = React.useState<{
        error: boolean;
        message: string;
    }>({ error: false, message: "" });
    const [companyValidNamesError, setCompanyValidNamesError] = React.useState<{
        error: boolean;
        message: string;
    }>({ error: false, message: "" });
    const [error, setError] = React.useState<{
        error: boolean;
        message: string;
    }>({ error: false, message: "" });
    const { t } = useTranslation();
    const { open, onClose, refresh, tenantId } = props;

    React.useEffect(() => {
        setError({ error: false, message: "" });
    }, []);

    const handleClose = () => {
        setCompanyName("");
        setCompanyValidNames([]);
        setCompanyNameError({ error: false, message: "" });
        setCompanyValidNamesError({ error: false, message: "" });
        setError({ error: false, message: "" });
        onClose();
    };

    // const validate = (): void => {
    //     if (companyName === "") {
    //         setCompanyNameError({
    //             error: true,
    //             message: t("employee.companies.createModal.companyNameError"),
    //         });
    //     } else {
    //         setCompanyNameError({ error: false, message: "" });
    //     }

    //     if (companyValidNames.length <= 0 || companyValidNames[0] === "") {
    //         setCompanyValidNamesError({
    //             error: true,
    //             message: t(
    //                 "employee.companies.createModal.companyValidNamesError",
    //             ),
    //         });
    //     } else {
    //         setCompanyValidNamesError({ error: false, message: "" });
    //     }
    // };

    const handleCreate = (): void => {
        if (companyName === "") {
            setCompanyNameError({
                error: true,
                message: t("yup.required"),
            });
            return;
        }

        companyService
            .create(
                companyName,
                companyValidNames.map((name) => name.trim()),
                tenantId
            )
            .then((res) => {
                refresh();
                setCompanyNameError({
                    error: false,
                    message: "",
                });
                handleClose();
            })
            .catch((err) => {
                const {
                    response: {
                        data: {
                            error: { message },
                        },
                    },
                } = err;
                console.log(message);
                // setError({
                //     error: true,
                //     message: err.response.data.error.message,
                // });
                setCompanyNameError({
                    error: true,
                    message: t(message),
                });
            });
    };

    return (
        <Dialog open={open} onClose={handleClose} fullWidth maxWidth={"sm"}>
            <DialogTitle>{t("company.create.title")}</DialogTitle>
            <DialogContent>
                <DialogContentText>
                    {error.error && (
                        <Box color="error.main">{t(error.message)}</Box>
                    )}
                </DialogContentText>
                <Box
                    sx={{
                        paddingTop: "0.50rem",
                        paddingBottom: "1rem",
                        height: "fit-content",
                    }}
                >
                    <TextField
                        label={t("company.labels.name")}
                        value={companyName}
                        onChange={(e) => {
                            setCompanyName(e.target.value);
                        }}
                        size="small"
                        error={companyNameError.error}
                        helperText={companyNameError.message}
                        sx={{ width: "100%" }}
                    />
                </Box>
                {/*<Box>
                    <TextField
                        label={t("company.labels.validNames")}
                        value={companyValidNames.join(",")}
                        onChange={(e) => {
                            setCompanyValidNames(e.target.value.split(","));
                        }}
                        size="small"
                        error={companyValidNamesError.error}
                        helperText={companyValidNamesError.message}
                        sx={{ width: "100%" }}
                    />
                </Box>*/}
            </DialogContent>
            <DialogActions>
                <Button
                    variant="contained"
                    color="primary"
                    onClick={handleClose}
                >
                    {t("company.create.cancel")}
                </Button>
                <Button
                    variant="contained"
                    color="success"
                    onClick={handleCreate}
                >
                    {t("company.create.create")}
                </Button>
            </DialogActions>
        </Dialog>
    );
};

export default CreateModal;
